import { useMemo, useState } from 'react';
import { SelectField, useHandleDependsOnFieldChange } from '@namespace/forms';
import { useDidUpdateEffect } from '@namespace/helpers';
import { getCitiesByRegion } from '../../utils/getCitiesByRegion';
import { mapListToOptions } from '../../utils/mapListToOptions';

const SELECT_TYPES = {
  SELECT: 'select',
  WITH_INPUT: 'with_input',
  SEARCH_SELECT: 'search_select'
};

export const Cities = ({ region, regionsList, ...props }) => {
  const [shouldSkipRelatedFieldsUpdate, setShouldSkipRelatedFieldsUpdate] =
    useState(true);

  useDidUpdateEffect(() => {
    setShouldSkipRelatedFieldsUpdate(false);
  }, [region]);

  useHandleDependsOnFieldChange('region', 'city', {
    skip: shouldSkipRelatedFieldsUpdate
  });

  const cities = useMemo(
    () => getCitiesByRegion(regionsList, region),
    [region, regionsList]
  );

  const options = useMemo(() => mapListToOptions(cities), [cities]);

  return (
    <SelectField
      options={options}
      selectType={SELECT_TYPES.SEARCH_SELECT}
      arrowSize="xs"
      hasSearch={true}
      noResetFormData={true}
      disableInputAutoClean={true}
      alwaysShowDropdownIcon={true}
      {...props}
    />
  );
};
